export const baseUri = window.location.protocol +'//'+ window.location.hostname + ':' + (window.location.protocol === 'http:' ? '5000' : '5443') + '/api/v1';